// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53573652","455":"e8a7b336","977":"beb7b869"}[chunkId] + ".chunk.js";
};